module.exports = __webpack_public_path__ + "static/cultivation_provisional-dec9431693fd17ab991fb35d435b1e1e.png";